import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import {
    UserInfoService,
    ShellDomainProvider
} from '@ecap3/core';
import { forkJoin, of, Subject } from 'rxjs';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';

export enum ResponseKeyCollection {
    hiringProcess,
    projectRequest,
    projetBooked,
    scheduleRestrict,
    projectAssigned,
    moreDocs,
    ProjectManpowerScheduleChanged,
    WishListSent,
    VehiclePlanNotificationSent,
    PayslipBeingGenerated,
    SuccessfullyGeneratedPayslips,
    ProjectInfoUpdatedSuccessfully,
    FailedCalculationMonthlyPayroll,
    SuccessfullyCalculatedMonthlyPayroll,
    OpenPositionRequestSuccessful,
    OpenPositionRequested,
    PickUpTimeAndPlaceUpdated,
    DocumentUpdatedInProject,
    RemovedFromVehicle,
    AssignedToVehicle,
    AssignedOnsiteLeader,
    NotifyAboutBookingSuccessfully,
    EmployeeReservation,
    EmployeeBooking,
    EmployeeWishListSent,
    EmployeeWishListSentSingleProject,
    EORTPlaceUpdated,
    ProjectCancelled,
    ProjectGenerated,
    WishlistDeadlineExpired,
    VehiclePlanningIncomplete,
    ProjectExpirationNotification,
    ReserveCancellation,
    ApprovedLeaveCancelled,
    AnnouncementCreatedSuccessfully,
    AssignSubOnsiteLeader,
    AdminApprovalOfProfileChange,
    InventoryTransactionRequest,
    TimeInputReminder,
    CommonResponseKey,
    LeaveRequestReminder,
    LeaveRequestNotifaction,
    AcceptOrRejectLeaveRequest,
    AssignedLogisticPerson,
    QualityReportReviewed,
    StandingRemoval,
	AddedOrRemovedLeave,
	LeaveRequestLastDayReminder,
    ProjectInformationChange,
    ProjectDescriptionChange,
	QualityReportCreated,
	WishlistAcceptingExpirationReminder,
    AnnouncementByRoleCreatedSuccessfully,
    SubOnsiteLeaderManpowerUpdate
}

@Injectable({
    providedIn: 'root'
})
export class OfflineNotificationService implements OnDestroy {
    private header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    onNotificationBtnClicked = new EventEmitter<any>();
    private _unsubscribeAll = new Subject<void>();
    private currentUser;
    responseKeyCollection;

    constructor(
        private userInfoService: UserInfoService,
        private http: HttpClient
    ) {
        this.responseKeyCollection = ResponseKeyCollection;
    }

    private getNotificationPayload(
        responseKey,
        message,
        title,
        recieverUserId,
        messageParamObj
    ) {
        const denormalizedObj = {
            time: new Date(),
            Success: true,
            messageKey: message,
            titleKey: title
        };
        for (const key in messageParamObj) {
            if (messageParamObj.hasOwnProperty(key)) {
                denormalizedObj[key] = messageParamObj[key];
            }
        }
        return {
            UserIds: [recieverUserId],
            NotificationType: 'UserSpecificReceiverType',
            ResponseKey: responseKey,
            // SubscriptionFilters: [{
            //   Context: responseKey
            // }],
            // ResponseValue: JSON.stringify({
            //   identifier: responseKey
            // }),

            DenormalizedPayload: JSON.stringify(denormalizedObj)
        };
    }

    saveTaskAsNotification(
        messageKey,
        proposedUserId,
        detailRoute,
        responseKey,
        titleKey?,
        paramObj?
    ) {
        if (!titleKey) {
            titleKey = null;
        }
        this.userInfoService.currentUser
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response: any) => {
                    if (response) {
                        this.currentUser = response;
                        this.sendNotificationToResponsiblePerson(
                            messageKey,
                            proposedUserId,
                            detailRoute,
                            responseKey,
                            titleKey,
                            paramObj
                        ).subscribe({
                            next: (result) => {}
                        });
                    }
                }
            });
    }

    getNotificationPayloadModel(
        messageKey,
        proposedUserId,
        detailRoute,
        responseKey,
        titleKey?,
        paramObj?
    ) {
        if (!titleKey) {
            titleKey = null;
        }
        if (!this.currentUser) {
            this.userInfoService.currentUser
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe({
                    next: (response: any) => {
                        if (response) {
                            this.currentUser = response;
                        }
                    }
                });
        }

        const messageParamObj = this.getParamsObj(
            detailRoute,
            titleKey,
            paramObj
        );
        // const messageParamObj = {
        //     TaskTitle: titleKey,
        //     TaskCreator: this.currentUser.DisplayName,
        //     DetailRoute: detailRoute,
        // };

        const _responsiblePerson = {
            ProposedUserId: proposedUserId
        };

        const payload = this.getNotificationPayload(
            responseKey,
            messageKey,
            titleKey,
            _responsiblePerson.ProposedUserId,
            messageParamObj
        );

        return payload;
    }

    saveTaskAsNotificationWithAggregate(payloads) {
        if (!payloads.length) return of(true);
        const notifyUrl = ShellDomainProvider['api'].NotificationService + '/api/Notifier/Notify';
        const calls$ = payloads.map(payload =>
            this.http.post(notifyUrl, payload, { headers: this.header, withCredentials: true, observe: 'response' })
                .pipe(catchError(() => of({ body: null })))
        );
        return forkJoin(calls$).pipe(
            map(() => true),
            catchError(() => of(false))
        );
    }

    getParamsObj(detailRoute, titleKey, paramObj?) {
        let messageParamObj: any = {};
        if (paramObj) {
            messageParamObj = JSON.parse(JSON.stringify(paramObj));
        }
        messageParamObj.TaskTitle = titleKey;
        messageParamObj.TaskCreator = this.currentUser.DisplayName;
        messageParamObj.DetailRoute = detailRoute;
        return messageParamObj;
    }

    private sendNotificationToResponsiblePerson(
        messageKey,
        proposedUserId,
        detailRoute,
        responseKey,
        titleKey,
        paramObj
    ) {
        const callList = [];
        const responseKeyList = [];
        const messageParamObj = this.getParamsObj(
            detailRoute,
            titleKey,
            paramObj
        );

        const _responsiblePerson = {
            ProposedUserId: proposedUserId
        };

        if (this.currentUser.UserId !== _responsiblePerson.ProposedUserId) {
            const payload = this.getNotificationPayload(
                responseKey,
                messageKey,
                titleKey,
                _responsiblePerson.ProposedUserId,
                messageParamObj
            );
            callList.push(payload);
        }

        if (!callList.length) return of(true);
        const notifyUrl = ShellDomainProvider['api'].NotificationService + '/api/Notifier/Notify';
        const notifyCalls$ = callList.map(payload =>
            this.http.post(notifyUrl, payload, { headers: this.header, withCredentials: true, observe: 'response' })
                .pipe(catchError(() => of({ body: null })))
        );
        return forkJoin(notifyCalls$).pipe(
            map(() => true),
            catchError(() => of(false))
        );
    }

    getBulkNotificationPayloadModel(
        messageKey,
        proposedUserId,
        detailRoute,
        responseKey,
        titleKey?,
        paramObj?
    ) {
        if (!titleKey) {
            titleKey = null;
        }
        if (!this.currentUser) {
            this.userInfoService.currentUser
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe({
                    next: (response: any) => {
                        if (response) {
                            this.currentUser = response;
                        }
                    }
                });
        }

        const messageParamObj = this.getParamsObj(
            detailRoute,
            titleKey,
            paramObj
        );
        const _responsiblePerson = {
            ProposedUserId: proposedUserId
        };

        const payload = this.getBulkNotificationPayload(
            responseKey,
            messageKey,
            titleKey,
            _responsiblePerson.ProposedUserId,
            messageParamObj
        );

        return payload;
    }

    private getBulkNotificationPayload(
        responseKey,
        message,
        title,
        recieverUserId,
        messageParamObj
    ) {
        const denormalizedObj = {
            time: new Date(),
            Success: true,
            messageKey: message,
            titleKey: title
        };
        for (const key in messageParamObj) {
            if (messageParamObj.hasOwnProperty(key)) {
                denormalizedObj[key] = messageParamObj[key];
            }
        }
        return {
            UserIds: recieverUserId,
            NotificationType: 'UserSpecificReceiverType',
            ResponseKey: responseKey,
            DenormalizedPayload: JSON.stringify(denormalizedObj)
        };
    }

    getAllNotificationForFloatingPanelLocal(payload: any) {
        const result = [];

        return this.http
            .post(
                ShellDomainProvider['api'].NotificationService +
                    '/api/Notifier/GetOfflineNotificationsByQuery',
                payload,
                {
                    headers: this.header,
                    withCredentials: true,
                    observe: 'response'
                }
            )
            .pipe(
                switchMap((response: any) => {
                    const firstResponse = response.body;
                    if (firstResponse['ErrorMessage']) return result;
                    return of(firstResponse);
                }),
                map((responseList: any) => {
                    return responseList;
                })
            );
    }

    markAllNotificationAsRead() {
        return this.http
            .post(
                ShellDomainProvider['api'].NotificationService +
                    '/api/Notifier/MarkAllNotificationAsRead',
                {},
                {
                    headers: this.header,
                    withCredentials: true,
                    observe: 'response'
                }
            )
            .pipe(
                map((res: any) => {
                    if (!res.body.Errors.IsValid) {
                        console.error(
                            `[OfflineNotificationService (markAllNotificationAsRead)] ${res.body.ErrorMessages[0]}`
                        );
                        throw new Error(res.body.ErrorMessages[0]);
                    }
                    return res.body;
                })
            );
    }

    ngOnDestroy() {
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }
}